import { useLogUTMParametersMutation } from 'src/store/services';
import { useGetUser, useQueryParams } from 'src/hooks';
import { useCallback, useEffect } from 'react';
import log from 'src/utils/logger';

export const useUTMMetrics = () => {
  const {
    searchParams: { utm_source, utm_medium, utm_campaign },
    removeMultipleSearchParams,
  } = useQueryParams();
  const { user_id } = useGetUser();

  const [sendUTMMetrics] = useLogUTMParametersMutation();

  const sendParams = useCallback(async () => {
    try {
      await sendUTMMetrics({
        user_id,
        source: utm_source,
        medium: utm_medium,
        campaign: utm_campaign,
      });
    } catch (e) {
      log.error(e);
    } finally {
      removeMultipleSearchParams(['utm_source', 'utm_medium', 'utm_campaign']);
    }
  }, [
    sendUTMMetrics,
    utm_source,
    utm_medium,
    utm_campaign,
    user_id,
    removeMultipleSearchParams,
  ]);

  useEffect(() => {
    if (!!utm_source || !!utm_medium || !!utm_campaign) {
      sendParams();
    }
  }, [utm_source, utm_medium, utm_campaign, sendParams]);
};
